export interface LogisticRequestRatingList {
  id: number;
  uniqueKey: number;
  // requests: {
  //   collection: 'logisticrequest';
  //   via: 'ratingid';
  //   through: 'logisticrequestsratings';
  // };
  name: string;
  color: string;
  type: number;
  // тип оценки:
  // 1- внутренняя
  // 2- отдел контроля качества
  // 3- расчетные теги
  level: number;
  // уровень оценки:
  // 0- нет ошибки
  // 1- не критичная ошибка
  // 2- критичная ошибка
  fixed?: boolean;
  qualityControlComment?: string | null;
  installerComment?: string | null;
  fixedBy?: string | null;
  createdBy?: string | null;
  updatedAt: string;
  createdAt: string;
}

export enum LogisticRequestRatingActionEnum {
  ON = 'on',
  OFF = 'off',
  Comment = 'comment',
}

export type RatingsStatus = Record<LogisticRequestRatingList['id'], boolean>;
